var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4988 17.3266C26.4988 16.6387 26.4322 15.9286 26.3212 15.2629H16.7129V19.1906H22.2161C21.9942 20.4554 21.2619 21.5649 20.1746 22.275L23.4587 24.8269C25.3893 23.0295 26.4988 20.4111 26.4988 17.3266Z",
    fill: "#4280EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7146 27.2677C19.4662 27.2677 21.774 26.3579 23.4604 24.8046L20.1763 22.2749C19.2665 22.8963 18.0904 23.2513 16.7146 23.2513C14.0518 23.2513 11.8106 21.4539 10.9895 19.0574L7.61664 21.6536C9.34747 25.0931 12.8535 27.2677 16.7146 27.2677Z",
    fill: "#34A353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9887 19.0354C10.5671 17.7705 10.5671 16.3948 10.9887 15.1299L7.61577 12.5115C6.17341 15.3962 6.17341 18.7913 7.61577 21.6538L10.9887 19.0354Z",
    fill: "#F6B704"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7146 10.936C18.157 10.9138 19.5771 11.4685 20.6201 12.4671L23.527 9.53799C21.6852 7.80716 19.2443 6.87517 16.7146 6.89736C12.8535 6.89736 9.34747 9.072 7.61664 12.5115L10.9895 15.1299C11.8106 12.7112 14.0518 10.936 16.7146 10.936Z",
    fill: "#E54335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.8687b76ba45d1dba2c034d092410e5fc.svg";
export { ForwardRef as ReactComponent };